import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import AdditionalJob from '../../types/api/additional-job'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const additionalJobsApi = createApi({
    reducerPath: 'additionalJobsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['AdditionalJobs'],
    endpoints: builder => ({
        getAdditionalJobs: builder.query<Strapi<AdditionalJob>, EndpointQueryParameters | void>({
            query: getQuery('/additional-jobs'),
            providesTags: ['AdditionalJobs'],
        }),
    }),
})

export const { useGetAdditionalJobsQuery } = additionalJobsApi
